<template>
  <div>
    <v-app-bar app color="primary" dark>
      <div class="d-flex flex-column">
        <div class="d-flex align-center">
          <v-img
            alt="BiblioTech"
            class="shrink mr-2"
            contain
            :src="require('../assets/BiblioTech.png')"
            transition="scale-transition"
            width="50"
          />
          <span class="mr-2">
            <span class="brand">{{ siteTitle }} </span>
          </span>
        </div>
        <span class="version">V {{ appVersion }}</span>
      </div>
      <v-spacer></v-spacer>
      <template v-if="!loggedIn">
        <v-btn href="/login" text>
          <v-icon class="mr-2">mdi-account</v-icon>
          <span>Login</span>
        </v-btn>
      </template>
      <template v-if="loggedIn">
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" class="ml-2 mr-2">
              <v-icon>mdi-account</v-icon>
              <span>{{ userName }}</span>
            </v-btn>
            <v-divider vertical></v-divider>
            <span class="mr-1">{{ organizationName }}</span>
          </template>
          <v-list>
            <v-list-item @click="logout()">
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Log out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-app-bar>
  </div>
</template>

<script>
import { mapState, mapGetter, mapActions } from "vuex";
import auth from "../api/auth-helper";
export default {
  name: "Header",
  computed: {
    ...mapState({ UserRole: "UserRole" }),
    siteTitle() {
      // return this.title = this.organizationName != '' ? 'eTBN Portal' : 'eTBN Hub' ;

      var titleName = "BiblioTech";
      if (this.UserRole == "HubAdmin") titleName = "BiblioTech Hub";
      else if (this.UserRole == "HubAdmin") titleName = "BiblioTech Portal";
      else if (this.UserRole == "Publisher") titleName = "BiblioTech Publisher";
      else titleName = "BiblioTech";
      return titleName;
    },
  },
  data: () => ({
    loggedIn: auth.loggedIn(),
    userName: auth.getUserName(),
    organizationName: auth.getOrganizationName(),
    title: "BiblioTech",
    appVersion: process.env.APP_VERSION,
  }),
  methods: {
    logout() {
      auth.logout();

      let currentUrl = window.location.pathname;
      console.log("currentUrl " + currentUrl);

      //this.$router.push({ name: 'login' })
      if (currentUrl.includes("organization")) window.location = "./../login";
      else window.location = "./login";
    },
  },
};
</script>
<style scoped>
.brand {
  font-size: 22px;
  font-weight: 500;
}
.version{font-size: 9px; margin-left: 10px; margin-top: 0PX; margin-bottom: 0px;}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue